import { YMAL_SET, YMAL_SET_DATA } from '../actionConstants';
import { ArticleGroup, Product, YmalObject } from './ymalTypes';
import { Action } from '../../generalTypes';

/**
 * Sets ymal
 *
 * @param articleGroups
 * @param articles
 */
export const setYmal = (
  articleGroups: ArticleGroup[],
  articles: Product[]
): Action<YmalObject> => {
  return {
    type: YMAL_SET,
    payload: { articleGroups, articles },
  };
};

/**
 * Set ymals data
 * @param ymals
 */
export const actionSetYmalData = (ymals: any) => ({
  type: YMAL_SET_DATA,
  payload: { ymals },
});
